export default () => {
	if ($('.featured-pages__list').length) {
		var $grid = $('.featured-pages__list').isotope({
			layoutMode: 'fitRows',
			// options
		});
			// filter items on button click
		$('.procedures__categories-list').on( 'click', 'button', function() {
			$('.procedures__categories-list button').removeClass('active');
			$(this).addClass('active');
			var filterValue = $(this).attr('data-filter');
			$grid.isotope({ filter: filterValue });
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/_filter-procedures.js